module.exports = __webpack_public_path__ + "static/redbull-1822ee03698bb5a0c15a3fca079c44eb.svg";